module.exports = __webpack_public_path__ + "static/media/background.36bb901c.jpg";